// Typelizer digest 63b2f153462dddd32e34e439f0e6c7b9
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../../runtime'
import { buildUrl } from '../../runtime'

export default {
  /** POST /c/:company_id/bank_connections/:bank_connection_id/authorization */
  create: (
    params: { bankConnectionId: string | number } | string | number,
    options?: RouteOptions,
  ): RouteDefinition<'post'> => ({
    url: buildUrl('/c/:company_id/bank_connections/:bank_connection_id/authorization', params, options),
    method: 'post',
  }),
}
